import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import {
  Overlay,
} from 'rebass';

import actions from 'frontend/state/actions';
import { selectors } from 'frontend/state/reducers/site';

import ShadowlandsLaunch from './Overlays/ShadowlandsLaunch';
import BfaLaunch from './Overlays/BfaLaunch';
import SimExpiration from './Overlays/SimExpiration';

const overlayMap = {
  'sl-notes': {
    component: ShadowlandsLaunch,
    componentWillDismiss: true,
  },
  'bfa-notes': {
    component: BfaLaunch,
    componentWillDismiss: true,
  },
  'sim-expiration': {
    component: SimExpiration,
    componentWillDismiss: true,
  },
};

const SiteOverlay = ({ overlay, onDismiss }) => {
  if (!overlay) {
    return null;
  }

  const overlayInfo = overlayMap[overlay];
  if (!overlayInfo) {
    return null;
  }
  const OverlayBody = overlayInfo.component;
  const componentWillDismiss = overlayInfo.componentWillDismiss || false;
  return (
    <Overlay
      open
      onDismiss={!componentWillDismiss ? onDismiss : null}
      style={{
        overflow: 'none',
      }}
    >
      <OverlayBody onDismiss={onDismiss} />
    </Overlay>
  );
};

SiteOverlay.propTypes = {
  overlay: PropTypes.string,
  onDismiss: PropTypes.func.isRequired,
};

SiteOverlay.defaultProps = {
  overlay: null,
};

SiteOverlay.displayName = 'SiteOverlay';

const mapStateToProps = state => ({
  overlay: selectors.overlay(state),
});

const mapDispatchToProps = {
  onDismiss: () => actions.showOverlay(''),
};

export default connect(mapStateToProps, mapDispatchToProps)(SiteOverlay);
